import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {
  private globalUrl: string;

  constructor(
    private configService: ConfigService,
    private httpClient: HttpClient
  ) {
    this.globalUrl = this.configService.getConfiguration().apiUrlData.global;
  }

  createPassword(email: string, pathToResetPasswordScreen: string): Observable<any> {
    const apiUrl = `profile/forgot-password/?login=${email}&returnurl=${pathToResetPasswordScreen}`;
    return this.httpClient.get<any>(this.globalUrl + apiUrl);
  }

  sendNewPassword(memberId: number, token: string, password: string): Observable<any> {
    const contentType = 'application/x-www-form-urlencoded';
    const body = `custId=${memberId}&token=${token}&password=${password}`;
    const apiUrl = this.globalUrl + `profile/reset-password`;
    return this.httpClient.post<any>(apiUrl, body, { headers: { 'Content-Type': contentType } });
  }
}
